/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsLoanApplicationsMortgagePropertyLiabilityRequest {
    

    yearAcquired?: number;

    yearBuilt?: number;

    mortgageBalance?: number;

    secondMortgageBalance?: number;

    originalPurchasePrice?: number;

    propertyType?: LDCLPBPPublicApiModelsLoanApplicationsMortgagePropertyLiabilityRequest.PropertyTypeEnum;

    manufacturedHomePropertyType?: LDCLPBPPublicApiModelsLoanApplicationsMortgagePropertyLiabilityRequest.ManufacturedHomePropertyTypeEnum;

    manufacturedHomeOwnership?: LDCLPBPPublicApiModelsLoanApplicationsMortgagePropertyLiabilityRequest.ManufacturedHomeOwnershipEnum;

    primaryBorrowerID?: string;

    annualPropertyTax?: number;

    currentFHALoan?: boolean;
}
export namespace LDCLPBPPublicApiModelsLoanApplicationsMortgagePropertyLiabilityRequest {

    export enum PropertyTypeEnum { 
        Unspecified = <any> 'Unspecified',
        SingleFamilyDetached = <any> 'SingleFamilyDetached',
        SingleFamilyAttached = <any> 'SingleFamilyAttached',
        AttachedLowRiseCondoOneToFour = <any> 'AttachedLowRiseCondoOneToFour',
        AttachedMidRiseCondoFiveToEight = <any> 'AttachedMidRiseCondoFiveToEight',
        AttachedHighRiseCondoNinePlus = <any> 'AttachedHighRiseCondoNinePlus',
        MixedUseCondo = <any> 'MixedUseCondo',
        RowHouse = <any> 'RowHouse',
        ManufacturedHome = <any> 'ManufacturedHome',
        DoubleWideMobile = <any> 'DoubleWideMobile',
        MixedUse = <any> 'MixedUse',
        SingleWideMobile = <any> 'SingleWideMobile',
        UnimprovedLandLot = <any> 'UnimprovedLandLot',
        CoOp = <any> 'CoOp',
        PropertyUnderDevelopment = <any> 'PropertyUnderDevelopment',
        Modular = <any> 'Modular',
        TwoUnit = <any> 'TwoUnit',
        ThreeUnit = <any> 'ThreeUnit',
        FourUnit = <any> 'FourUnit',
        DetachedCondo = <any> 'DetachedCondo',
        NonWarrantableCondo = <any> 'NonWarrantableCondo',
    }

    export enum ManufacturedHomePropertyTypeEnum { 
        Unspecified = <any> 'Unspecified',
        ManufacturedHomeAndLand = <any> 'ManufacturedHomeAndLand',
        ManufacturedHomeAndNotLand = <any> 'ManufacturedHomeAndNotLand',
        NotApplicable = <any> 'NotApplicable',
    }

    export enum ManufacturedHomeOwnershipEnum { 
        Unspecified = <any> 'Unspecified',
        DirectOwnership = <any> 'DirectOwnership',
        IndirectOwnership = <any> 'IndirectOwnership',
        PaidLeasehold = <any> 'PaidLeasehold',
        UnpaidLeashold = <any> 'UnpaidLeashold',
        NotApplicable = <any> 'NotApplicable',
    }
}
